const backendPrefix = '/api/document/';
const frontendPrefix = '/doc/';

/**
 * Тип описывающий документ
 * @typedef {Object} DocDef
 * @property {string} backend
 * @property {string} frontend
 * @property {func} lister
 * @property {func} selector
 */

/**
 * @const
 * @type {object}
 * @property {DocDef} subscriptions
 */

// eslint-disable-next-line
export const documents = {
  subscriptions: {
    backend: `${backendPrefix}subscriptions/`,
    frontend: `${frontendPrefix}subscriptions/`,
  },
  contracts: {
    backend: '/api/catalog/contracts/',
    frontend: `${frontendPrefix}contracts/`,
  },
  subscriptions412: {
    backend: `${backendPrefix}subscriptions412/`,
    frontend: `${frontendPrefix}subscriptions412/`,
  },
  calculatedcontracts: {
    backend: '/api/catalog/calculatedcontracts/',
    frontend: `${frontendPrefix}calculatedcontracts/`,
  },
  enteringtheremainder: {
    backend: '/api/document/enteringtheremainder/',
    frontend: `${frontendPrefix}enteringtheremainder/`,
  },
  calculationofpayments: {
    backend: '/api/document/calculationofpayments/',
    frontend: `${frontendPrefix}calculationofpayments/`,
  },
  grksubscriptions: {
    backend: '/api/document/grksubscriptions/',
    frontend: `${frontendPrefix}grksubscriptions/`,
  },
  household: {
    backend: '/api/household/households/',
    frontend: `${frontendPrefix}household/`,
  },
};

export default documents;
